/* ============
 * Organization Member Transformer
 * ============
 *
 * The transformer for the organization type.
 */

import Transformer from './transformer';

export default class OrganizationMemberProductBusinessHourTransformer extends Transformer {
  static fetch(organizationMemberProductBusinessHour) {
    return {
      id: organizationMemberProductBusinessHour.id,
      day: organizationMemberProductBusinessHour.day,
      startTime: organizationMemberProductBusinessHour.start_time,
      endTime: organizationMemberProductBusinessHour.end_time,
      organizationMemberProduct: organizationMemberProductBusinessHour.organization_member_product,
    };
  }

  static send(organizationMemberProductBusinessHour) {
    return {
      day: organizationMemberProductBusinessHour.day,
      start_time: organizationMemberProductBusinessHour.startTime,
      end_time: organizationMemberProductBusinessHour.endTime,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/organizationMemberProductBusinessHour.js